import { Observable, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAbstractPresenter, IconName, ILanguageObject, INotificationMessage } from '@core/interfaces';
import { selectLanguaje, selectNotification } from '@store/selectors/core.selectors';
import { NOTIFICATION_CLEAR } from '@store/actions';
import { Injectable } from '@angular/core';
import { I18nService } from '@core/services';
import { ComponentEnum, LanguajeEnum } from '@core/enums';
import { INotificationComponent, INotificationPresenter } from './interfaces';

@Injectable({ providedIn: 'root' })
export class NotificationPresenter
	extends IAbstractPresenter<INotificationComponent>
	implements INotificationPresenter
{
	notification$: Observable<INotificationMessage | null>;
	translations: ILanguageObject;
	notification: INotificationMessage | null = null;
	icon: IconName | null = 'alert-small'; 
	private notificationTimeout: ReturnType<typeof setTimeout> | null = null;

	constructor(
		private store: Store,
		private i18nService: I18nService
	) {
		super();
		this.notification$ = this.store.select(selectNotification);
		this.translations = this.i18nService.getTranslations(ComponentEnum.Notification);
	}

	dispatchActions(): void {}

	suscribeObservers(): void {
		this.store
			.select(selectLanguaje)
			.pipe(takeUntil(this.destroy$))
			.subscribe((lang: LanguajeEnum) => {
				this.translations = this.i18nService.getTranslations(ComponentEnum.Notification, lang);
			});

		this.notification$
			.pipe(takeUntil(this.destroy$))
			.subscribe((value: INotificationMessage | null) => {
				this.view.notification = value;

				switch (value?.type) {
					case 'success':
						this.view.icon = 'check';
						break;
					case 'error':
						this.view.icon = 'close';
						break;
				}

				if (value) {
					this.clearNotification(value.timeout);
				} else {
					this.cancelNotificationTimeout();
				}
			});
	}

	notificationClass(): string {
		if (!this.view.notification?.type) return '';

		return this.view.notification.type;
	}

	clearNotification(timeout: number = 5000): void {
		this.cancelNotificationTimeout();
		this.notificationTimeout = setTimeout(() => {
			this.notificationTimeout = null;
			this.store.dispatch(NOTIFICATION_CLEAR());
		}, timeout);
	}

	override onDestroy(): void {
		super.onDestroy();
		this.cancelNotificationTimeout();
	}

	closeNotification(): void {
		this.clearNotification(0);
	}

	private cancelNotificationTimeout(): void {
		if (this.notificationTimeout === null) return;

		clearTimeout(this.notificationTimeout);
		this.notificationTimeout = null;
	}
}
